/**
 * Renders text with every case-insensitive occurrence of `query` wrapped in a
 * mark, so search hits visually announce themselves. The mark adds no spacing: a
 * value reads exactly as it is written, inside an email address too.
 *
 * Empty query → renders the text as-is.
 * No match → renders the text as-is (silent — the caller decides whether
 * to hide rows with no match).
 */
import type React from 'react'

interface Props {
  text: string
  query?: string
}

export function HighlightedText({ text, query }: Props): React.ReactElement {
  if (!query) return <>{text}</>
  // A capture group keeps the matches in the split: they are its odd parts.
  const parts = text.split(new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'ig'))
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          // The look is the global `mark` style, whose padding would split a value in two.
          <mark key={i} className="p-0! font-medium">
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </>
  )
}
